import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

class ParkingApi {
  static async getAll() {
    const result = await axios.get(`${url}/admin/parking`, {
      headers: authHeader(),
    });
    
    return result.data
  }

  static async getOne(id: any) {
    const result = await axios.get(`${url}/admin/parking/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }
}

export default ParkingApi;
